import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  noScroll() {
    const body = document.body;
    body.classList.toggle('noscroll')
  }
}
